<template>
  <Header headerClass="transparent"/>
  <main>
    <div class="wrapper fadeInDown">
      <div id="formContent">
        <div class="fadeIn first mt-4">
          <LogoSVG/>
        </div>

        <div v-if="step === 'credentials'" class="row d-flex justify-content-center mt-3">
          <input
              type="text"
              name="email"
              v-model="email"
              id="login"
              class="fadeIn second"
              :placeholder="$t('placeholders.email')"
              :disabled="isLoading"
          />
          <input
              type="password"
              name="password"
              v-model="password"
              id="password"
              class="fadeIn third"
              :placeholder="$t('placeholders.password')"
              :disabled="isLoading"
          />
        </div>

        <div v-if="step === 'credentials'" class="row d-flex justify-content-center mx-4">
          <input
              @click="requestOtp"
              type="submit"
              class="fadeIn fourth mt-3 w-100"
              :value="isLoading ? 'LOADING' : $t('global.login')"
              :disabled="isLoading || !email || !password"
          />
        </div>

        <div v-if="step === 'otp'" class="row d-flex justify-content-center mt-3 mx-4">
          <input
              type="text"
              name="otp"
              v-model="otpCode"
              id="otp"
              class="fadeIn second"
              placeholder="OTP Code"
              inputmode="numeric"
              maxlength="6"
              :disabled="isLoading"
              @keyup.enter="verifyOtp"
          />

          <div class="row d-flex justify-content-center mx-4">
            <input
                @click="verifyOtp"
                type="submit"
                class="fadeIn fourth mt-3 w-100"
                :value="isLoading ? 'LOADING' : 'Verify OTP'"
                :disabled="isLoading || otpCode.length < 4"
            />
          </div>

          <div class="row d-flex justify-content-center mx-4">
            <input
                @click="resendOtp"
                type="button"
                class="fadeIn fourth mt-2 w-100"
                value="Resend OTP"
                :disabled="isLoading"
            />
          </div>

          <div class="row d-flex justify-content-center mx-4">
            <input
                @click="backToCredentials"
                type="button"
                class="fadeIn fourth mt-2 w-100"
                value="Back"
                :disabled="isLoading"
            />
          </div>
        </div>
        <div v-if="infoText" class="px-4 pb-3">
          <small class="text-muted">{{ infoText }}</small>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Header from "@/components/Header.vue";
import LogoSVG from "@/components/LogoSVG.vue";
import { string } from "yup";

export default {
  name: "App",
  components: { Header, LogoSVG },

  data() {
    const schemaEmail = {
      email: string().required(this.$t("errors.email-req")).email(this.$t("errors.email-req")),
      password: string().required(this.$t("errors.password-req")),
    };

    return {
      schemaEmail,
      email: "",
      password: "",

      step: "credentials",
      isLoading: false,
      infoText: "",

      tempToken: "",
      otpCode: "",
    };
  },

  methods: {
    backToCredentials() {
      this.step = "credentials";
      this.infoText = "";
      this.otpCode = "";
      this.tempToken = "";
    },

    async requestOtp() {
      this.isLoading = true;
      this.infoText = "";

      try {
        const resp = await this.$appAxios.post("admin/account/login", {
          email: this.email,
          password: this.password,
          token: "",
        });

        this.tempToken = resp?.data?.tempToken || "";
        this.infoText = resp?.data?.message || "OTP sent.";

        if (!this.tempToken) throw new Error("tempToken missing from response");

        this.step = "otp";
        this.otpCode = "";
      } catch (err) {
        const apiErr =
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message ||
            "Login failed";
        this.showGlobalErrorMessage(apiErr);
      } finally {
        this.isLoading = false;
      }
    },

    async resendOtp() {
      await this.requestOtp();
    },

    async verifyOtp() {
      if (!this.tempToken) {
        this.showGlobalErrorMessage("tempToken missing. Please login again.");
        this.backToCredentials();
        return;
      }

      this.isLoading = true;
      this.infoText = "";

      try {
        const resp = await this.$appAxios.post(
            "admin/account/verify-otp",
            { code: this.otpCode },
            {
              headers: {
                authorization: `Bearer ${this.tempToken}`,
              },
            }
        );

        this.$store.commit("setToken", resp.data.token);

        this.tempToken = "";

        this.$router.push("/");
      } catch (err) {
        const status = err?.response?.status;
        const apiErr =
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.response?.data ||
            "OTP verify failed";

        if (status === 423 || String(apiErr).toLowerCase().includes("lock")) {
          this.showGlobalErrorMessage("Hesabın kilitlenmiş görünüyor. Lütfen daha sonra tekrar dene.");
          return;
        }

        this.showGlobalErrorMessage(apiErr);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
main {
  height: 100vh;
}


body {
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}


.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}



input[type=button], input[type=submit], input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 20px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover, input[type=submit]:hover, input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active, input[type=submit]:active, input[type=reset]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input:placeholder {
  color: #cccccc;
}

.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

#icon {
  width: 60%;
}
</style>
